export const SITE_URL = "https://rahmanidrees1.web.app";

export const DEFAULT_SEO = {
  title:
    "Rahman Idrees | Enterprise SaaS Developer | MERN, Oracle Fusion API & Web3",
  description:
    "Rahman Idrees builds enterprise SaaS platforms, Oracle Fusion API integrations, invoicing and accounting systems, React/Next.js dashboards, and Web3 DApps.",
  keywords:
    "Rahman Idrees, enterprise SaaS developer, MERN stack developer, Oracle Fusion API integration, invoicing software developer, accounting software developer, React dashboard developer, Next.js dashboard developer, Web3 DApp developer, wallet integration",
  image:
    "https://raw.githubusercontent.com/ahmadit575/Portfolio/main/Images/readme-img.png",
};

export const PAGE_SEO = {
  "/": {
    ...DEFAULT_SEO,
    path: "/",
  },
  "/project": {
    title:
      "Case Studies | Enterprise SaaS, Oracle Fusion, Accounting & Web3 Projects",
    description:
      "Explore Rahman Idrees case studies across Oracle Fusion invoicing, accounting software, SaaS dashboards, MERN platforms, and Web3 wallet integrations.",
    keywords:
      "Oracle Fusion invoicing case study, accounting software case study, SaaS dashboard portfolio, Web3 DApp portfolio, MERN stack projects",
    path: "/project",
  },
  "/about": {
    title:
      "About Rahman Idrees | Enterprise SaaS, MERN, Oracle Fusion API & Web3",
    description:
      "Learn about Rahman Idrees, an enterprise SaaS and MERN stack developer focused on Oracle Fusion API integrations, accounting systems, dashboards, and Web3 DApps.",
    keywords:
      "Rahman Idrees about, MERN stack engineer, enterprise SaaS developer, Oracle Fusion API developer, Web3 developer",
    path: "/about",
  },
  "/resume": {
    title: "Resume | Rahman Idrees - Enterprise SaaS & MERN Stack Developer",
    description:
      "View Rahman Idrees' resume for enterprise SaaS development, MERN stack engineering, Oracle Fusion API integration, accounting systems, and Web3 DApps.",
    keywords:
      "Rahman Idrees resume, MERN stack resume, SaaS developer resume, Oracle Fusion API resume, Web3 developer resume",
    path: "/resume",
  },
  "/social-proof": {
    title:
      "Hire Rahman Idrees | Fiverr, Upwork & Project Consultation",
    description:
      "Start a project consultation with Rahman Idrees for enterprise SaaS, Oracle Fusion API, invoicing, accounting systems, dashboards, and Web3 DApps.",
    keywords:
      "hire Rahman Idrees, Fiverr MERN developer, Upwork Web3 developer, project consultation, SaaS developer contact",
    path: "/social-proof",
  },
};

export function buildCanonical(path = "/") {
  const cleanPath = path === "/" ? "" : path.replace(/\/$/, "");
  return `${SITE_URL}${cleanPath}`;
}

function setMeta(selector, attribute, value) {
  if (!value || typeof document === "undefined") {
    return;
  }

  const element = document.querySelector(selector);
  if (element) {
    element.setAttribute(attribute, value);
  }
}

function setMetaByName(name, content) {
  setMeta(`meta[name="${name}"]`, "content", content);
}

function setMetaByProperty(property, content) {
  setMeta(`meta[property="${property}"]`, "content", content);
}

function setItemProp(prop, content) {
  setMeta(`meta[itemprop="${prop}"]`, "content", content);
}

function setCanonical(url) {
  if (typeof document === "undefined") {
    return;
  }

  let canonical = document.querySelector('link[rel="canonical"]');
  if (!canonical) {
    canonical = document.createElement("link");
    canonical.setAttribute("rel", "canonical");
    document.head.appendChild(canonical);
  }
  canonical.setAttribute("href", url);
}

export function applySeo(seo = DEFAULT_SEO) {
  if (typeof document === "undefined") {
    return;
  }

  const title = seo.title || DEFAULT_SEO.title;
  const description = seo.description || DEFAULT_SEO.description;
  const keywords = seo.keywords || DEFAULT_SEO.keywords;
  const image = seo.image || DEFAULT_SEO.image;
  const canonical = seo.canonical || buildCanonical(seo.path || "/");

  document.title = title;
  setCanonical(canonical);

  setMetaByName("description", description);
  setMetaByName("keywords", keywords);
  setMetaByName("twitter:title", title);
  setMetaByName("twitter:description", description);
  setMetaByName("twitter:image", image);

  setMetaByProperty("og:title", title);
  setMetaByProperty("og:description", description);
  setMetaByProperty("og:image", image);
  setMetaByProperty("og:url", canonical);
  setMetaByProperty("og:type", seo.type || "website");

  setItemProp("name", title);
  setItemProp("description", description);
  setItemProp("image", image);
}
